import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { getTasks } from "../api/training-hub.js";

export const trainingHubTaskStore = SwApiStore({
  get: () => getTasks(),
  init: () => ({ tasks: [], taskCards: [], totalProgress: {} }),
  onMessage: ({ message }) => {
    if (message.kind !== "training-hub-task") return;
    trainingHubTaskStore.get();
  },
});
